<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="false"
      @close="closeDialog"
      custom-class="dialog_normalcontact"
      class="dialog_contact dialog_modal"
      :append-to-body="true"
      title="Contact Information"
    >
      <div class="detail_cont">
        <div class="right_cont_box">
          <div class="table_box p_l_n">
            <el-table
              ref="treeTable"
              style="
                max-height: 471px;
                overflow-y: auto;
                width: 960px;
                border-radius: 8px;
                border: 1px solid #cccccc;
              "
              class="table_height_50 table_contentHeight_40 computer_right_cont_box"
              :data="managementTable1"
              border
              show-overflow-tooltip
              tooltip-effect="light"
            >
              <!-- 空数据状态的插槽 -->
              <template slot="empty"> No Data </template>
              <el-table-column
                :label="$t('Management.Name')"
                prop="name"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                class-name="company_link"
                tooltip-effect="light"
              >
                <template slot-scope="scope">
                  <span class="">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('Management.Position')"
                prop="position"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                tooltip-effect="light"
              />

              <el-table-column
                :label="$t('Management.Email')"
                prop="email"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                tooltip-effect="light"
              >
              </el-table-column>
              <el-table-column
                :label="$t('Management.Phone')"
                prop="phone"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                tooltip-effect="light"
              />
              <el-table-column
                label="Source"
                prop="linkedin"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                tooltip-effect="light"
              />
            </el-table>
            <div class="page_i_box">
              <Page
                :totalFont="true"
                :total="pageTree.total"
                :pageSize.sync="pageTree.pageSize"
                :currentPage="pageTree.pageNo"
                @onPageChange="onPageChangeListTree"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ pageTree.pageNo }}-{{ pageTree.pageSize }} of over
                {{ pageTree.total | FilterNum }} results for "Contact
                Information"
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog_footer">
        <button type="button" class="el-close" @click="closeDialog">
          <span>Close</span>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchMoreEmail } from "@/api/companyApi";
import Page from "@/components/page/index.vue";

export default {
  components: {
    Page,
  },

  props: {
    suoClose: {
      type: Boolean,
      //   default: false,
    },
    ContactObj: {
      type: Object,
    },
  },
  data() {
    return {
      pageTree: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      managementTable1: [],
      //page: this.currentPage

      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        if (this.suoClose) {
          this.searhinfo();
        }
        return this.suoClose;
      },
      set() {},
    },
  },
  destroyed() {
    // bus.$off('handleShowLogin');
  },
  mounted() {},
  methods: {
    onPageChangeListTree({ page, size }) {
      this.pageTree.pageNo = page;
      this.pageTree.size = size;
      this.searhinfo();
    },
    searhinfo() {
      let params = {};

      params = {
        page: this.pageTree.pageNo,
        pageSize: this.pageTree.pageSize,
        id3a: this.ContactObj.aaa_id,
        website: this.ContactObj.web_site,
        countryCode: this.ContactObj.company_country,
      };

      searchMoreEmail(params).then((result) => {
        if (result.code == 200) {
          this.managementTable1 =
            result.data?.contacts == undefined ? [] : result.data?.contacts;
          this.pageTree.total =
            result.data?.total == undefined ? "" : result.data?.total;
        } else {
          this.managementTable1 = [];
          this.pageTree.total = 0;
        }
      });
    },
    //关闭弹窗
    closeDialog() {
      this.pageTree.pageNo = 1;
      this.pageTree.pageSize = 10;
      this.$emit("closeCloseDialog", false);
    },
  },
};
</script>
<style scoped>
::v-deep .el-table__header-wrapper {
  width: 960px !important;
  height: 49px !important;
  font-size: 18px !important;
  line-height: 24px !important;
}
::v-deep .el-dialog__headerbtn {
  height: 18px !important;
  width: 18px !important;
  top: 20px !important;
  right: 20px !important;
}

::v-deep .dialog_normalcontact {
  width: 1000px !important;
  max-height: 702px !important;
  border-radius: 30px !important;
}

::v-deep .el-dialog__body {
  padding: 20px !important;
  box-shadow: none;
}

.el-close {
  width: 210px;
  height: 60px;
  background: #009ea7;
  border-radius: 10px;
  color: #ffffff;
  font-size: 20px;
  font-family: "Arial Bold";
}
::v-deep .el-table td.el-table__cell {
  height: 60px !important;
}

::v-deep .table_box .el-table th > .cell {
  padding-left: 10px !important;
}

::v-deep .el-table--border .el-table__cell:first-child .cell {
  padding-left: 20px !important;
  font-size: 18px !important;
}
.pageBox_right {
  height: 45px !important;
  font-size: 16px !important;
}
.dialog_contact >>> .el-dialog__footer {
  padding-top: 0;
}
.dialog_contact >>> .el-dialog__header {
  padding: 20px 20px 0px;
}
.dialog_contact >>> .el-dialog__title {
  font-family: "Arial Bold";
  font-size: 26px;
  line-height: auto;
  color: #1a2332;
}
::v-deep .el-table__body tr:hover > td {
  background-color: #eafafa !important;
}
::v-deep .el-table ::-webkit-scrollbar {
  height: 0px !important;
}
.page_i_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
}
::v-deep .search_rsult_txt {
  position: relative;
  width: auto;
  height: auto;
  font-size: 16px;
  top: 0;
}

::v-deep .pageBox_right {
  height: 45px !important;
  font-size: 16px !important;
}
.right_cont_box {
  padding: 0;
  box-shadow: none;
}
@media (max-width: 1920px) {
  ::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 15px !important;
    font-size: 16px !important;
  }
  ::v-deep .table_box .el-table th > .cell {
    padding-left: 7px !important;
  }
  ::v-deep .el-table td.el-table__cell {
    height: 45px !important;
  }
  .el-close {
    width: 157px;
    height: 45px;
    background: #009ea7;
    border-radius: 7px;
    color: #ffffff;
    font-size: 18px;
    font-family: "Arial Bold";
  }
  ::v-deep .el-dialog__body {
    padding: 15px !important;
  }
  ::v-deep .dialog_normalcontact {
    width: 750px !important;
    max-height: 526px !important;
    border-radius: 22px !important;
  }
  ::v-deep .el-dialog__headerbtn {
    height: 18px !important;
    width: 18px !important;
    top: 20px !important;
    right: 20px !important;
  }
  .dialog_contact >>> .el-dialog__header {
    padding: 15px 15px 0px;
  }
  .dialog_contact >>> .el-dialog__title {
    font-size: 20px;
  }
  .search_rsult_txt {
    font-size: 14px;
  }
  .pageBox_right {
    height: 30px !important;
    font-size: 14px !important;
  }
  .pageBox {
    height: 40px !important;
  }
}
@media (max-width: 1439px) {
  ::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 13px !important;
    font-size: 14px !important;
  }
  ::v-deep .table_box .el-table th > .cell {
    padding-left: 6px !important;
  }
  ::v-deep .el-table td.el-table__cell {
    height: 40px !important;
  }
  .el-close {
    width: 140px;
    height: 40px;
    background: #009ea7;
    border-radius: 6px;
    color: #ffffff;
    font-size: 16px;
    font-family: "Arial Bold";
  }
  ::v-deep .el-dialog__body {
    padding: 13px !important;
  }
  ::v-deep .dialog_normalcontact {
    width: 670px !important;
    max-height: 470px !important;
    border-radius: 20px !important;
  }
  ::v-deep .el-dialog__headerbtn {
    height: 18px !important;
    width: 18px !important;
    top: 20px !important;
    right: 20px !important;
  }
  .dialog_contact >>> .el-dialog__header {
    padding: 12px 12px 0px;
  }
  .dialog_contact >>> .el-dialog__title {
    font-size: 18x;
  }
  .search_rsult_txt {
    font-size: 12px;
  }
  .pageBox_right {
    height: 30px !important;
    font-size: 12px !important;
  }
}
</style>
